import React, { useState, useEffect } from 'react'
import Icon from 'components/icon/icon'

import { getDashboardOnboardingSteps } from 'utils'

export default ({
    user,
    account
}) => {
    const [hasMounted, setHasMounted] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setHasMounted(true)
        },100)
    }, [])

    const items = getDashboardOnboardingSteps(account, user)

    const checkIfComplete = key => {
        return key === 'HOP_IN' || (user && user.onboarded_enums && user.onboarded_enums.includes(key))
    }

    const percentComplete = (() => {
        let totalComplete = 0
        let totalItems = items.length

        items.forEach(item => {
            const isComplete = checkIfComplete(item.key)

            if (isComplete) {
                totalComplete++
            }
        })

        return (totalComplete / totalItems) * 100
    })()

    return (
        <div className={`widget box dashboard-onboarding ${ hasMounted ? 'mounted' : ''}`}>
            <div className="bg" />
            <div className={'outer'}>
                <h3>
                    Let's get you set up!
                </h3>
                <p>
                    It's super easy, and you're already on your way.
                </p>
                <div className={'inner'}>
                    <div className={'progress'}>
                        <div style={{
                            height: `${percentComplete}%`
                        }} />
                    </div>
                    <ul>
                        {items.map(({
                            key, label
                        }, index) => {
                            const isComplete = checkIfComplete(key)

                            return (
                                <li 
                                    className={isComplete ? 'complete' : ''} 
                                    key={key}
                                    style={{
                                        transitionDelay: (index/10)+'s'
                                    }}
                                >
                                    <span className={'circle'}>
                                        {isComplete ?
                                            <Icon name="check" />
                                            : null}
                                    </span>
                                    {label}
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}